var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.312,
    height: 25,
    viewBox: "0 0 24.312 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m127.9 48.746 1.292-7.755a5.331 5.331 0 0 0-1.7-4.862l-7.6-6.836a4.152 4.152 0 0 0-5.568 0l-7.6 6.837a5.331 5.331 0 0 0-1.7 4.862l1.292 7.755a5.338 5.338 0 0 0 5.282 4.474h11.012a5.338 5.338 0 0 0 5.282-4.476zm-7.687-2.883a.579.579 0 0 1-.862-.772 3 3 0 1 0-2.239 1 .579.579 0 1 1 0 1.157 4.16 4.16 0 1 1 3.1-1.389z",
    transform: "translate(-104.959 -28.222)",
    style: {
      fill: "#ea7d36"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.bc0fb736e1c71f1eeac50c3e10c9df71.svg";
export { ForwardRef as ReactComponent };